import { DeviceDTOV1, PatchDeviceDTOV1 } from '../swagger-api-v1';
import { Position } from 'models/geofence';

export type DeviceType = DeviceDTOV1.TypeEnum;
export const DeviceType = DeviceDTOV1.TypeEnum;

export type VPNState = DeviceDTOV1.VpnStatusEnum;
export const VPNState = DeviceDTOV1.VpnStatusEnum;

export type ProtectionStatus = DeviceDTOV1.ProtectionStatusEnum;
export const ProtectionStatus = DeviceDTOV1.ProtectionStatusEnum;

export interface VPNStatus {
  active: boolean;
  state: VPNState;
}

type DeviceIcon =
  | 'smartphone'
  | 'language'
  | 'escalator_warning'
  | 'desktop_windows'
  | 'computer'
  | 'tap_and_play';

const DeviceIconMap: Map<DeviceType, DeviceIcon> = new Map([
  [DeviceType.MOBILE_CHILD_PROTECTION, 'escalator_warning'],
  [DeviceType.MOBILE, 'smartphone'],
  [DeviceType.ONNET, 'language'],
  [DeviceType.WINDOWS, 'desktop_windows'],
  [DeviceType.DESKTOP, 'computer'],
  [DeviceType.ONNET_MOBILE_CHILD_PROTECTION, 'tap_and_play']
]);

export class Device {
  constructor(
    public id: number,
    public msisdn: string,
    public name: string,
    public type: DeviceType,
    public profileName: string,
    public profileId: number,
    public typeIcon: string,
    public location: Position,
    public protectionStatus: ProtectionStatus
  ) {}

  public static fromDTO(dto: DeviceDTOV1): Device {
    return new Device(
      dto.id!,
      dto.msisdnPrimary || dto.msisdnSecondary,
      dto.name!,
      dto.type!,
      dto.profileName,
      dto.profileId,
      DeviceIconMap.get(dto.type),
      { lat: dto.latitude!, lng: dto.longitude! },
      dto.protectionStatus
    );
  }

  public toDTO(): PatchDeviceDTOV1 {
    return {
      id: this.id,
      name: this.name.trim(),
      profileId: this.profileId
    } as PatchDeviceDTOV1;
  }

  get isChildProtection(): boolean {
    return (
      this.type === DeviceType.MOBILE_CHILD_PROTECTION ||
      this.type === DeviceType.ONNET_MOBILE_CHILD_PROTECTION
    );
  }

  get isOnnet(): boolean {
    return (
      this.type === DeviceType.ONNET ||
      this.type === DeviceType.ONNET_MOBILE_CHILD_PROTECTION ||
      this.type === DeviceType.ONNET_MOBILE
    );
  }

  get locationString(): string {
    return this.location.lng && this.location.lat
      ? `${this.location.lat}, ${this.location.lng}`
      : 'unknown';
  }
}
